import React from "react";
import useMountedState from "./useMountedState";

export default function useDelayedEffect(effect: React.EffectCallback, delay: number, deps?: React.DependencyList) {
  const { getMounted } = useMountedState();
  React.useEffect(() => {
    setTimeout(() => {
      if (getMounted()) effect();
    }, delay);
  }, deps);
}
